import type { BroadcastCountrySlice, FiltersSlice, LivescoreState } from './types';

import type { StateCreator } from '@shared-types/zustand.types';
import type { D3Country } from '@utilities/country';

const filtersSlice: StateCreator<FiltersSlice> = (set) => ({
  filters: {
    competition: null,
  },
  setFilters: (filters) => set({ filters }, false, 'setFilters'),
});

const broadcastCountrySlice: StateCreator<BroadcastCountrySlice> = (set) => ({
  broadcastCountry: null as D3Country,
  setBroadcastCountry: (country) => set({ broadcastCountry: country }, false, 'setBroadcastCountry'),
});

export const reducer: StateCreator<LivescoreState> = (...args) => ({
  ...filtersSlice(...args),
  ...broadcastCountrySlice(...args),
});
